import { types, actions } from './requests'
export const GETBABYPRESSADATA_TYPES = {
    ...types('GETBABYPRESSADATA'),
}
export const GETBABYPRESSADATA_ACTIONS = {
    ...actions('GETBABYPRESSADATA'),
}
